import { Reducer } from "redux";

import { EligibilityCheckResponse } from "../models/api/Patient";
import { EligibilityCheckDispatchTypes } from "../models/dispatchTypes/Patient";
import { EligibilityCheckActionDispatchTypes } from "../constants/Patient";

export const initialState: EligibilityCheckResponse = {
  loading: false,
  response: {
    additionalNotes: {
      apiRequestId: "",
      benefitPlanUid: "",
      healthPlanUid: "",
      eligibilityState: 0,
      scrubbedSubscriberID: "",
      scrubbedZipCode: "",
      scrubbedZipCodeExtension: "",
      verificationServiceResponded: false
    },
    record: {
      subscriberGender: "",
      version: "",
      subscriberName: {
        last: "",
        first: "",
      },
      subscriberId: "",
      subscriberDOB: "",
      subscriberAddress: {
        street: "",
        city: "",
        state: "",
        zip: "",
      },
      subscriberDTLoop: {
        subscriberDT: [],
      },
      benefitsLoop: {
        benefits: [],
      },
    },
    supplementalInformation: {
      info: [
        {
          employeeId: "",
          groupOrPolicyNumber: "",
          employmentStatusCode: "",
          handicapIndicator: "",
          lastTouchedDate: "",
          hicNumber: "",
          mbi: "",
          medicaidId: "",
          mobilePhone: "",
          homePhone: "",
          alternatePhone: "",
          workPhone: "",
          emailAddress: "",
          employerName: "",
          studentStatusCode: "",
          userDefined1: "",
          userDefined2: "",
          userDefined3: "",
          userDefined4: "",
          userDefined5: "",
          userDefined6: "",
          userDefined7: "",
          userDefined8: "",
          userDefined9: "",
          userDefined10: "",
          userDefined11: "",
          userDefined12: "",
          memberFound: "",
          address: {
            addressType: "",
            addressLine: "",
            addressLine2: "",
            city: "",
            state: "",
              zipCode: "",
            countryCode: "",
              county: ""
          },
          addresses: [
            {
              addressType: "Residential",
              addressLine: "",
              addressLine2: "",
              city: "",
              state: "",
              zipCode: "",
              countryCode: "",
              county: ""
            },
            {
              addressType: "Mailing",
              addressLine: "",
              addressLine2: "",
              city: "",
              state: "",
              zipCode: "",
              countryCode: "",
              county: ""
            }
          ],
          healthCoverage: {
            planCoverageDescription: "",
            groupOrPolicyNumber: "",
            insuranceLineCode: "",
            coverageLevelCode: "",
            beginDate: "",
            endDate: "",
            providerInfo: {
              orgOrLastName: "",
              firstName: "",
              providerIdentifier: "",
              addressLine: "",
              cityName: "",
              stateCode: "",
              zipCode: "",
              providerType: "",
            },
          },
        },
      ],
    },
  },
  error: null,
};

const PostEligibilityCheckReducer: Reducer<
  EligibilityCheckResponse,
  EligibilityCheckDispatchTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case EligibilityCheckActionDispatchTypes.ELIGIBILITY_CHECK_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case EligibilityCheckActionDispatchTypes.ELIGIBILITY_CHECK_SUCCESS: {
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
    case EligibilityCheckActionDispatchTypes.ELIGIBILITY_CHECK_ERROR: {
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    }
    case EligibilityCheckActionDispatchTypes.ELIGIBILITY_CHECK_RESET: {
      return initialState;
    }
  }
  return state;
};

export default PostEligibilityCheckReducer;
